import { render } from "./AfterdocMigration.vue?vue&type=template&id=24ad4aa8&scoped=true"
import script from "./AfterdocMigration.vue?vue&type=script&lang=js"
export * from "./AfterdocMigration.vue?vue&type=script&lang=js"

import "./AfterdocMigration.vue?vue&type=style&index=0&id=24ad4aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ad4aa8"]])

export default __exports__